export default {
      id: "city-icon-5-usage",
      viewBox: "0 0 92 80",
      url: __webpack_public_path__ + "sprite.svg#city-icon-5",
      toString: function () {
        return this.url;
      }
    }